import Vue from 'vue';
import last from 'lodash/last';
import moment from 'dayjs';
import uuidv4 from 'uuid/v4';
import config from 'config';
import delay from 'lodash/delay';
import VueResource from 'vue-resource';

Vue.use(VueResource);

Vue.http.options.crossOrigin = true;
Vue.http.options.xhr = { withCredentials: true };
const api = config.hosts.mall + '/api/b/dataAcquisition/getDataAcquisition';
// const api = 'http://172.16.10.68:8082/api/b/dataAcquisition/getDataAcquisition'

const dateFormatStr = 'YYYY-MM-DD HH:mm:ss';
let pageInTime = moment(); // 初始化app页面时间

let requestBody = {};
let clientIp = undefined;
let net = undefined;
let sessionId = undefined;
let appPauseMoment = undefined;
const geolocation = {};

const isIOS = navigator.userAgent.toLowerCase().match(/iphone|ipad/i);

const networkType = {
  // 1=3G   2=4G   3=wifi  4=有线
  cellular: 2,
  MOBILE: 2,
  wifi: 3,
  WIFI: 3,
  '4G': 2,
  '3G': 1,
  '4g': 2,
  '3g': 1,
  none: 0,
  NONE: 0,
  unknown: '',
  UNKNOWN: ''
}; //只是为了枚举出网络类型方便埋点

export function getNetwork () {
  const m = navigator.userAgent.match(/(NetType)\/([\w\.-]+)/i);
  if (m && m.length > 2) {
    const netType = m[2];
    return networkType[netType];
  }
}

function log(action, route, index = '') {
  try {
    console.group(`%c ${action} %c ${route ? route.id : ''} ${route ? route.__title : ''} ${index}`, 'color: #1e90ff', 'color: #000');
    route && console.log(JSON.stringify(route));
    console.groupEnd();
  } catch (e) {
    console.log(`—— log end ——`);
  }
}

export function getUUID() {
  let uuid = localStorage.getItem('user_uuid');
  if (!uuid) {
    uuid = uuidv4();
    localStorage.setItem('user_uuid', uuid);
  }
  return uuid;
}

export function getProductId() {

}

export function getSessionId() {
  if (!sessionId) {
    sessionId = uuidv4();
  }
  return sessionId;
}

// 如果app在后台超过30分钟则refreshUUID
export function refreshSessionId() {
  console.log(`----------------refreshUUID---lastUUID:${sessionId}`);
  const duration = moment() - appPauseMoment;
  if (moment.duration(duration).as('hours') > 0.5) {
    sessionId = uuidv4();
  }
  console.log(`----------------refreshUUID---currentUUID:${sessionId}`);
}

// 路由跳转监听
export async function addRouteAnalytics(endRoute, startRoute) {
  try {
    const lastPageInTime = pageInTime;
    pageInTime = moment();
    const duration = pageInTime - lastPageInTime;
    // endRoute.fullPath
    uploadData({
      appType: 0,
      lastPath: location.origin + startRoute.fullPath,
      currentPath: location.origin + endRoute.fullPath,
      mapParam: JSON.stringify({
        params: { ...endRoute.params, ...endRoute.query }
      }),
      // funcid: startRoute.id,
      // funcname: document.title,
      startTime: pageInTime.format(dateFormatStr),
      // stayTime: moment.duration(duration).as('seconds'),
      stayTime: duration / 1000,
      time: moment().format(dateFormatStr)
    });
  } catch (ex) {
    console.log('埋点错误', ex);
  }
}

// 列表加载监听
export async function addListAnalytics(url, data = {}) {
  try {
    let queryObj = new URL(url, true).query;
    queryObj = { ...queryObj, ...data };
    if (queryObj.page && queryObj.pageSize && queryObj.pageSize > 500) {
      uploadData({
        mapParam: JSON.stringify({
          page
        }),
        appType: 3
      });
    }
  } catch (ex) {
    console.log('埋点错误', ex);
  }
}

// 点击监听
export async function addClickAnalytics(props) {
  try {
    const mapParam = JSON.stringify({
      route: location.href,
      title: props.LogTitle
    });
    // console.log('addClickAnalytics mapParam:::', mapParam);
    uploadData({
      mapParam,
      appType: props.LogActionType || 1 // 0页面浏览 1 单独点击
    });
  } catch (ex) {
    console.log('埋点错误', ex);
  }
}

// 初始化请求数据
async function initRequestBody() {
  return {
    UUID: await getUUID(), // 每个用户生成一次uuid,如果不存在则生成，否则读取sqlite中的uuid发送   必填
    // deviceId: md.os().toLowerCase().indexOf('android') !== -1 ? DeviceInfo.getUniqueID() : DeviceInfo.getImei(),
    appSourceType: 4, // 1=pc  2=ios  3=android  4=H5  5=其他
    productId: getProductId(),
    version: 'h5',
    resolution: `${window.screen.width}*${window.screen.height}`, //屏幕分辨率
    // osVersion: DeviceInfo.getSystemVersion(),
    browser: window.navigator.userAgent

    // 以下不作处理
    // keyWord: '',
    // serverTime: '',
    // mapParam: '',
    // accdb: '', //erp
    // storageid: '',
    // yuns: '',
    // cpu: '', //
    // country: '',
    // province: '',
    // city: '',
    // isp: '',
    // adclient: '',
    // adID: ''
  };
}

// 用户相关数据收集
async function getUserData() {
  const member = G.member;
  const enterprise = G.enterprise;
  return {
    username: member.userNo || '',
    enterprise_no: enterprise || config.enterprise
  };
}

function toQueryString(obj) {
  return obj
    ? Object.keys(obj)
      .filter(k => {
        return obj[k] !== undefined && obj[k] !== null;
      })
      .map(k => {
        return encodeURIComponent(k) + '=' + encodeURIComponent(obj[k]);
      })
      .join('&')
    : '';
}

// 获取ip地址
export async function getIpAddress() {
  try {
    const res = await fetch('https://api.ip.sb/jsonip');
    const ip = (await res.json()).ip;
    return ip;
  } catch (ex) {
    return '';
  }
}

// 发送数据
function uploadData(data = {}) {
  delay(async () => {
    const userData = await getUserData();
    const body = {
      ...requestBody,
      sessionId: getSessionId(),
      clientIp,
      net: getNetwork(),
      ...userData,
      ...data
    };

    // console.log('埋点发送数据----->', body);
    Vue.http.post(api, body, {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      },
      timeout: 0
    }).then(res => {
      // console.log('埋点数据返回 ---- > ', res.ok ? res.body : res)
    }).catch(err => {
      console.log('埋点请求发生错误 ---- > ', err);
    });
  }, 100);
}

// APP启动时注册数据统计服务
export async function registerAnalytics() {
  requestBody = await initRequestBody();
}




// WEBPACK FOOTER //
// ./src/utils/analytics.js